export default "__VITE_ASSET__UW372$f7__"